/* DESTGLOW_APP_LOADING_V6: bounded error recovery; preserved consent and scheduling. */
(function () {
  'use strict';
  if (window.DestGlowAppLoading || (window.Shopify && window.Shopify.designMode)) return;
  var tasks = {};
  var state = {};
  var pageLoaded = document.readyState === 'complete';
  var startedAt = pageLoaded ? Date.now() : 0;
  var privacyRequested = false;
  var privacyAttempts = 0;
  var privacyTimer;
  var config = document.getElementById('dg-app-loading-config');
  if (!config) return;

  function allowed() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    try {
      return !!(privacy && typeof privacy.marketingAllowed === 'function' &&
        typeof privacy.analyticsProcessingAllowed === 'function' &&
        privacy.marketingAllowed() && privacy.analyticsProcessingAllowed());
    } catch (error) { return false; }
  }

  function loadScript(id, src, existingSelector, callback, complete) {
    var existing = document.getElementById(id) || document.querySelector(existingSelector);
    var script = existing || document.createElement('script');
    var settled = false;
    function cleanup() {
      script.removeEventListener('load', onLoad);
      script.removeEventListener('error', onError);
    }
    function onLoad() {
      if (settled) return;
      settled = true;
      cleanup();
      script.setAttribute('data-dg-loaded', 'true');
      state[id] = existing ? 'existing' : 'loaded';
      if (!allowed()) { complete(false); return; }
      try {
        if (callback && callback() === false) { complete(false); return; }
        complete(true);
      } catch (error) {
        state[id] = 'initialization-failed';
        complete(false);
      }
    }
    function onError() {
      if (settled) return;
      settled = true;
      cleanup();
      state[id] = 'load-failed';
      // Only remove scripts created here. Never delete an app's own installation.
      if (!existing) script.remove();
      complete(false);
    }
    if (existing && !callback) { state[id] = 'existing'; complete(true); return; }
    if (existing && (existing.getAttribute('data-dg-loaded') === 'true' ||
        (window.merchantwidget && typeof window.merchantwidget.start === 'function'))) {
      onLoad();
      return;
    }
    script.addEventListener('load', onLoad, { once: true });
    script.addEventListener('error', onError, { once: true });
    if (existing) { state[id] = 'waiting-existing'; return; }
    script.id = id;
    script.async = true;
    script.src = src;
    state[id] = 'loading';
    document.head.appendChild(script);
  }

  function loadKlaviyo(complete) {
    var key = config.getAttribute('data-klaviyo-key') || '';
    if (!/^[A-Za-z0-9]{6}$/.test(key)) { complete(false); return; }
    window._learnq = window._learnq || [];
    loadScript('dg-klaviyo-v5', 'https://static.klaviyo.com/onsite/js/' + key + '/klaviyo.js',
      'script[src*="static.klaviyo.com/onsite/js/"][src*="/klaviyo.js"]', null, complete);
  }

  function loadGoogleWidget(complete) {
    loadScript('merchantWidgetScript', 'https://www.gstatic.com/shopping/merchant/merchantwidget.js',
      'script[src*="/shopping/merchant/merchantwidget.js"]', function () {
        if (!window.merchantwidget || typeof window.merchantwidget.start !== 'function') {
          state.merchantWidgetScript = 'api-unavailable';
          return false;
        }
        if (document.querySelector('iframe#merchantwidgetiframe, #google-merchantwidget-iframe-wrapper iframe')) return true;
        window.merchantwidget.start({
          position: 'LEFT_BOTTOM', sideMargin: 36, bottomMargin: 36,
          mobileSideMargin: 16, mobileBottomMargin: 46
        });
        return true;
      }, complete);
  }

  function execute(name) {
    var task = tasks[name];
    if (!task || task.done || task.running || task.queued || task.attempts >= 2 ||
        !pageLoaded || document.hidden || !allowed()) return;
    task.queued = true;
    var work = function () {
      task.queued = false;
      if (task.done || task.running || document.hidden || !allowed()) return;
      task.running = true;
      task.attempts = (task.attempts || 0) + 1;
      var completed = false;
      function complete(success) {
        if (completed) return;
        completed = true;
        task.running = false;
        task.done = success === true;
        if (!task.done && task.attempts < 2) {
          task.retryAt = Date.now() + 1000;
          schedule(name, false);
        }
      }
      try { task.run(complete); }
      catch (error) { complete(false); }
    };
    if (typeof window.requestIdleCallback === 'function') window.requestIdleCallback(work, { timeout: 1500 });
    else window.setTimeout(work, 0);
  }

  function schedule(name, expedited) {
    var task = tasks[name];
    if (!task) return;
    // Remember relevant intent even when the page or consent API is still loading.
    if (expedited) task.expedited = true;
    if (task.done || task.running || task.queued || task.attempts >= 2 || !pageLoaded) return;
    var remaining = task.expedited ? 0 : Math.max(0, task.delay - (Date.now() - startedAt));
    remaining = Math.max(remaining, (task.retryAt || 0) - Date.now());
    window.clearTimeout(task.timer);
    task.timer = window.setTimeout(function () { execute(name); }, remaining);
  }
  tasks.klaviyo = { delay: 4000, run: loadKlaviyo };
  tasks.google = { delay: 7000, run: loadGoogleWidget };

  function refresh() {
    Object.keys(tasks).forEach(function (name) { schedule(name, false); });
  }
  function initPrivacy() {
    if (window.Shopify && window.Shopify.customerPrivacy) {
      window.clearTimeout(privacyTimer);
      refresh();
      return;
    }
    if (privacyRequested || privacyAttempts >= 3 || !window.Shopify ||
        typeof window.Shopify.loadFeatures !== 'function') return;
    privacyRequested = true;
    privacyAttempts += 1;
    function finished(error) {
      privacyRequested = false;
      if (!error && window.Shopify && window.Shopify.customerPrivacy) { refresh(); return; }
      if (privacyAttempts < 3) {
        window.clearTimeout(privacyTimer);
        privacyTimer = window.setTimeout(initPrivacy, privacyAttempts * 1000);
      }
    }
    try {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], finished);
    } catch (error) { finished(error); }
  }
  function onLoad() {
    if (!pageLoaded) { pageLoaded = true; startedAt = Date.now(); }
    initPrivacy();
    refresh();
  }
  // Only a relevant interaction expedites its own integration. Reviews do not release marketing.
  document.addEventListener('focusin', function (event) {
    var target = event.target;
    if (target && target.closest && target.closest('[data-dg-load-klaviyo], [class*="klaviyo-form-"]')) {
      schedule('klaviyo', true);
    }
  });
  document.addEventListener('visitorConsentCollected', function () { initPrivacy(); refresh(); });
  document.addEventListener('visibilitychange', function () { if (!document.hidden) { initPrivacy(); refresh(); } });
  window.DestGlowAppLoading = { version: 6, state: state };
  if (pageLoaded) onLoad();
  else window.addEventListener('load', onLoad, { once: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initPrivacy, { once: true });
  else initPrivacy();
})();
